export enum CypressToastClassNames {
    Container = "cy-toast-container",
    Toast = "cy-toast",
}

export enum ToastClassNames {
    Container = "orbit-toast-container",
    Toast = "orbit-toast",
    ProgressBar = "orbit-toast-progress-bar"
}

export enum ToastStylingClassNames {
    ResetStyles = "orbit-toast-reset-styles",
    FrostedGlassBg = "orbit-toast-frosted-glass-background",
    StandardBg = "orbit-toast-frosted-glass-background",
    WithPadding = "orbit-toast-with-padding",
    NoPadding = "orbit-toast-no-padding",
    WithBorderStandard = "orbit-toast-with-border-standard",
    WithBorderLight = "orbit-toast-with-border-light",
    NoBorder = "orbit-toast-no-border",
    WithShadow = "orbit-toast-shadow",
    FreeWidth = "orbit-toast-free-width",
    StandardWidth = "orbit-toast-standard-width",
}

export function toastClassName(className?: string | undefined) {
    let toastClassNames: string = ToastClassNames.Toast + " " + CypressToastClassNames.Toast;
    if (!className) {
        return toastClassNames;
    }
    return toastClassNames + " " + className;
}